// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__B3UYZ","comment":"styles_comment__1Iz0N"};